module.exports = __webpack_public_path__ + "static/media/destacados-6.ceae48c7.png";